import type { FormatterMap, ProductRoutesOptions, RouteList } from '@grandvisionhq/frk-routing'
import { createSimpleFormatter } from '@grandvisionhq/frk-routing'
import {
  createAuthFormatters,
  createCheckoutFormatters,
  createMultilangFormatter,
  createMyAccountFormatters,
  productDetailFormatters,
  productListFormatter,
} from '@grandvisionhq/www-next/formatters'

export const excludeSkuFromProductUrls = true

const productRoutesOptions: Record<string, ProductRoutesOptions> = {
  'nl-BE': {
    'contact-lenses': 'contactlenzen',
    frames: 'brillen',
    solutions: 'contactlenzen/vloeistof',
    sunglasses: 'zonnebrillen',
    'ready-readers': 'brillen/kant-en-klare-leesbrillen',
  },
  'fr-BE': {
    'contact-lenses': 'lentilles',
    frames: 'lunettes',
    solutions: 'lentilles/produits-entretien',
    sunglasses: 'solaires',
    'ready-readers': 'lunettes/de-lecture-pretes-a-emploi',
  },
}

export const localRouteFormatters: FormatterMap = {
  home: createSimpleFormatter('/'),
  'auth.reset': createSimpleFormatter('my-account/reset'),

  'express.checkout.login': createSimpleFormatter('express-user-checkout'),
  'express-checkout': createSimpleFormatter('express-checkout'),
  'order.confirm': createSimpleFormatter('order/confirm'),
  'cart.overview': createSimpleFormatter('cart'),

  'appointments.book': createMultilangFormatter({
    'nl-BE': 'maak-afspraak',
    'fr-BE': 'prendre-rendez-vous',
  }),
  'appointments.cancel': createMultilangFormatter({
    'nl-BE': 'cancel-appointment',
    'fr-BE': 'cancel-appointment',
  }),
  'appointments.reschedule': createMultilangFormatter({
    'nl-BE': 'reschedule-appointment',
    'fr-BE': 'reschedule-appointment',
  }),

  ...createMyAccountFormatters(),
  ...createAuthFormatters(),
  ...createCheckoutFormatters({
    path: 'checkout',
    children: { login: 'login', shipping: 'shipping', overview: 'overview', payment: 'payment' },
  }),
  ...productListFormatter(productRoutesOptions),
  ...productDetailFormatters(productRoutesOptions, { excludeSku: excludeSkuFromProductUrls }),
  wishlist: createSimpleFormatter('/wishlist'),
}

export const routes: RouteList = [
  ['/', 'home'],

  ['/checkout/login', 'checkout.login'],
  ['/checkout/shipping', 'checkout.shipping'],
  ['/checkout/overview', 'checkout.overview'],
  ['/checkout/payment', 'checkout.payment'],
  ['/api/payment-callback', 'payment.callback'],
  ['/order/confirm', 'order.confirm'],

  ['/nl_BE/maak-afspraak{/*path}', 'appointments.book'],
  ['/nl_BE/reschedule-appointment', 'appointments.reschedule'],
  ['/nl_BE/cancel-appointment', 'appointments.cancel'],

  ['/fr_BE/prendre-rendez-vous{/*path}', 'appointments.book'],
  ['/fr_BE/reschedule-appointment', 'appointments.reschedule'],
  ['/fr_BE/cancel-appointment', 'appointments.cancel'],
]
